import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "sidebar-section" }
const _hoisted_2 = { class: "sidebar-section__overview" }
const _hoisted_3 = { class: "sidebar-section__title label-m" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "sidebar-section__line" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "sidebar-section__date label-m"
}
const _hoisted_6 = { class: "sidebar-section__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _hoisted_4,
      (_ctx.date)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.formattedDate), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}